import TextArea from './Textarea.component';

export default TextArea;
